(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vogalab-intro')) {
    customElements.define('vogalab-intro', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        const initialize = () => {
          this._initializationFrame = requestAnimationFrame(() => { this.initializeNavigation(); this.initializePlayer(); });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: this._abort.signal });
        } else initialize();
      }
      initializeNavigation() {
        if (!this.querySelector('[data-guide-navigation]')) return;
        const refresh = () => {
          cancelAnimationFrame(this._navigationFrame);
          this._navigationFrame = requestAnimationFrame(() => this.updateNavigation());
        };
        for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
          document.addEventListener(event, refresh, { signal: this._abort.signal });
        }
        this.updateNavigation();
      }
      updateNavigation() {
        if (!this.isConnected) return;
        const nav = this.querySelector('[data-guide-navigation]');
        if (!nav) return;
        const namespace = this.dataset.vogalabGuideKey;
        const targets = new Map();
        for (const target of document.querySelectorAll('[data-vogalab-topic]')) {
          if (target.dataset.vogalabTopicKey !== namespace || !target.id) continue;
          if (!targets.has(target.dataset.vogalabTopic)) targets.set(target.dataset.vogalabTopic, target);
        }
        let visible = 0;
        for (const link of nav.querySelectorAll('[data-topic-link]')) {
          const target = targets.get(link.dataset.topicLink);
          link.closest('li').hidden = !target;
          if (target) {
            link.setAttribute('href', `#${target.id}`);
            visible += 1;
          } else link.removeAttribute('href');
        }
        nav.hidden = visible === 0;
      }
      initializePlayer() {
        if (!this.isConnected || !this._abort || this._abort.signal.aborted) return;
        const signal = this._abort.signal;
        const video = this.querySelector('.vlg01__video');
        if (!video) return;
        const controls = this.querySelector('[data-native-controls]');
        const play = this.querySelector('[data-play]');
        const mute = this.querySelector('[data-mute]');
        const seek = this.querySelector('[data-seek]');
        const time = this.querySelector('[data-time]');
        const caption = this.querySelector('[data-native-caption]');
        const fullscreen = this.querySelector('[data-fullscreen]');
        const player = this.querySelector('.vlg01__player');
        const error = this.querySelector('[data-player-error]');
        if (!controls || !play || !mute || !seek || !player) return;
        const formatTime = (seconds) => {
          const value = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
          const minutes = Math.floor(value / 60);
          return `${minutes}:${String(value % 60).padStart(2, '0')}`;
        };
        const update = () => {
          const playing = !video.paused && !video.ended;
          play.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
          play.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
          play.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
          const muted = video.muted || video.volume === 0;
          mute.setAttribute('aria-label', muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
          mute.querySelector('[data-sound-icon]').toggleAttribute('hidden', muted);
          mute.querySelector('[data-muted-icon]').toggleAttribute('hidden', !muted);
          const duration = video.duration;
          seek.disabled = !Number.isFinite(duration) || duration <= 0;
          if (!seek.disabled) seek.value = String(video.currentTime / duration * 100);
          seek.setAttribute('aria-valuetext', `${formatTime(video.currentTime)} / ${formatTime(duration)}`);
          if (time) time.textContent = `${formatTime(video.currentTime)} / ${formatTime(duration)}`;
        };
        const playVideo = () => {
          if (error) error.hidden = true;
          const promise = video.play();
          if (promise) promise.catch(() => {
            if (!this.isConnected || video.paused && !video.error) return;
            if (error) error.hidden = false;
          });
        };
        play.addEventListener('click', () => { if (video.paused || video.ended) playVideo(); else video.pause(); }, { signal });
        mute.addEventListener('click', () => {
          if (video.volume === 0) { video.volume = 1; video.muted = false; }
          else video.muted = !video.muted;
        }, { signal });
        seek.addEventListener('input', () => {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          video.currentTime = Number(seek.value) / 100 * video.duration;
          update();
        }, { signal });
        this.querySelector('[data-watch]')?.addEventListener('click', playVideo, { signal });
        for (const event of ['play', 'pause', 'ended', 'timeupdate', 'loadedmetadata', 'durationchange', 'volumechange']) {
          video.addEventListener(event, update, { signal });
        }
        video.addEventListener('error', () => {
          if (error) error.hidden = false;
          video.controls = true;
          controls.hidden = true;
          if (caption) caption.hidden = false;
        }, { signal });
        if (fullscreen) {
          fullscreen.hidden = !player.requestFullscreen && !video.webkitEnterFullscreen;
          fullscreen.addEventListener('click', async () => {
            try {
              if (document.fullscreenElement === player) await document.exitFullscreen();
              else if (player.requestFullscreen) await player.requestFullscreen();
              else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
            } catch { video.controls = true; }
          }, { signal });
        }
        update();
        controls.hidden = false;
        if (caption) caption.hidden = true;
        video.controls = false;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._initializationFrame);
        cancelAnimationFrame(this._navigationFrame);
        this._abort?.abort();
        this._abort = null;
        const video = this.querySelector('.vlg01__video');
        if (video) { video.pause(); video.controls = true; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /* VOGALAB presentation only: enrich the theme's existing disclosure nodes. */
  if (!customElements.get('vogalab-header-menu-layout')) {
    customElements.define('vogalab-header-menu-layout', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.additions = [];
        this.classChanges = [];
        this.attributeChanges = [];
        this.styleChanges = [];
        this.entries = [];
        this.timers = new Set();
        const start = () => { if (this.isConnected && !this.abort.signal.aborted) this.mount(); };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.abort.signal });
        } else {
          queueMicrotask(start);
        }
      }

      on(node, event, callback) {
        node.addEventListener(event, callback, { signal: this.abort.signal });
      }

      mark(node, name) {
        if (!node.classList.contains(name)) {
          node.classList.add(name);
          this.classChanges.push([node, name]);
        }
      }

      attribute(node, name, value) {
        this.attributeChanges.push([node, name, node.getAttribute(name)]);
        node.setAttribute(name, value);
      }

      rows(node, count) {
        this.styleChanges.push([node, node.style.getPropertyValue('--vh-menu-rows')]);
        node.style.setProperty('--vh-menu-rows', String(count));
      }

      mount() {
        const root = document.getElementById('shopify-section-' + this.dataset.sectionId);
        const nav = root?.querySelector('.header__inline-menu');
        const topList = nav?.querySelector(':scope > ul.list-menu--inline');
        if (!topList) return;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        const topItems = Array.from(topList.children).filter(node => node.tagName === 'LI');

        if (this.dataset.highlightUrl) {
          const normalize = value => {
            try { const url = new URL(value, document.baseURI); return url.origin + url.pathname.replace(/\/$/, '') + url.search; }
            catch (_) { return value; }
          };
          const wanted = normalize(this.dataset.highlightUrl);
          topItems.forEach(item => {
            const link = item.querySelector(':scope > a');
            if (link && normalize(link.getAttribute('href')) === wanted) this.mark(link, 'vh-highlight');
          });
        }

        this.querySelectorAll(':scope > template[data-vh-menu-template]').forEach(template => {
          const position = Number(template.dataset.position);
          if (!Number.isInteger(position) || position < 0) return;
          const topItem = topItems[position];
          const disclosure = topItem?.querySelector(':scope > header-menu');
          const details = disclosure?.querySelector(':scope > details');
          const summary = details?.querySelector(':scope > summary');
          const panel = summary?.nextElementSibling;
          if (!details || !panel) return;
          const isMega = panel.classList.contains('mega-menu__content');
          const isDropdown = panel.tagName === 'UL' && panel.classList.contains('header__submenu');
          if (!isMega && !isDropdown) return;
          const list = isMega ? panel.querySelector(':scope > .mega-menu__list') : panel;
          if (!list) return;
          const items = Array.from(list.children).filter(node => node.tagName === 'LI');
          const itemTemplates = Array.from(template.content.children).filter(node => node.matches('template[data-vh-item-template]'));
          // A theme with an unexpected menu structure keeps its original output.
          if (!items.length || items.length !== itemTemplates.length) return;
          const labels = items.map(item => item.querySelector(':scope > a, :scope > details > summary'));
          if (labels.some(label => !label)) return;
          const rowCount = Math.ceil(items.length / 2);
          this.attribute(details, 'data-vh-menu', '');
          this.mark(panel, 'vh-menu-panel');
          this.mark(panel, isMega ? 'vh-mega' : 'vh-dropdown');
          this.rows(isMega ? list : panel, rowCount);
          if (isMega) this.mark(list, 'vh-menu-grid');
          items.forEach((item, i) => { this.mark(item, 'vh-menu-group'); this.mark(labels[i], 'vh-menu-link'); });
          const entry = {
            disclosure, details, summary, panel, list, labels, itemTemplates,
            promoTemplate: template.content.querySelector('template[data-vh-promo-template]'),
            isMega, hydrated: false, timer: null
          };
          this.entries.push(entry);
          this.on(details, 'toggle', () => {
            if (details.open) {
              this.cancelClose(entry);
              summary.setAttribute('aria-expanded', 'true');
              if (this.desktop.matches) this.hydrate(entry);
              this.entries.forEach(other => { if (other !== entry && other.details.open) this.close(other); });
            } else {
              summary.setAttribute('aria-expanded', 'false');
            }
          });

          /* Desktop behavior: hover opens the dropdown; clicking the top-level
             menu label follows the Shopify navigation link instead of toggling
             the <details> disclosure. Mobile keeps Dawn's native drawer behavior. */
          const topUrl = template.dataset.topUrl?.trim();
          if (topUrl && topUrl !== '#') {
            this.on(summary, 'click', event => {
              if (!this.desktop.matches) return;
              event.preventDefault();
              event.stopPropagation();
              window.location.assign(topUrl);
            });
          }
          this.on(details, 'pointerenter', event => {
            this.cancelClose(entry);
            if (!this.hover.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
            this.hydrate(entry);
          });
          this.on(details, 'pointerleave', () => {
            if (!this.hover.matches) return;
            this.cancelClose(entry);
            entry.timer = setTimeout(() => {
              this.timers.delete(entry.timer);
              entry.timer = null;
              if (!details.contains(document.activeElement)) this.close(entry);
            }, 180);
            this.timers.add(entry.timer);
          });
          this.on(details, 'keydown', event => {
            if (event.key !== 'Escape' || !details.open) return;
            // Nested disclosures keep the theme's own Escape handling.
            if (event.target.closest('details') !== details) return;
            event.preventDefault();
            event.stopPropagation();
            this.close(entry);
            summary.focus();
          });
          if (details.open && this.desktop.matches) this.hydrate(entry);
        });

        this.on(document, 'pointerdown', event => {
          this.entries.forEach(entry => {
            if (entry.details.open && !event.composedPath().includes(entry.details)) this.close(entry);
          });
        });
        this.on(this.desktop, 'change', () => {
          this.entries.forEach(entry => {
            if (!this.desktop.matches) this.close(entry);
            else if (entry.details.open) this.hydrate(entry);
          });
        });
      }

      hydrate(entry) {
        if (entry.hydrated) return;
        entry.hydrated = true;
        entry.labels.forEach((label, index) => {
          const thumb = entry.itemTemplates[index].content.firstElementChild?.cloneNode(true);
          if (thumb) { label.prepend(thumb); this.additions.push(thumb); }
        });
        const promo = entry.promoTemplate?.content.firstElementChild?.cloneNode(true);
        if (promo) {
          const holder = document.createElement(entry.isMega ? 'div' : 'li');
          holder.className = 'vh-promo-holder';
          holder.append(promo);
          entry.panel.append(holder);
          this.additions.push(holder);
        }
      }

      cancelClose(entry) {
        if (entry.timer !== null) {
          clearTimeout(entry.timer);
          this.timers.delete(entry.timer);
          entry.timer = null;
        }
      }

      close(entry) {
        this.cancelClose(entry);
        if (typeof entry.disclosure.close === 'function') entry.disclosure.close();
        entry.details.open = false;
        entry.summary.setAttribute('aria-expanded', 'false');
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.timers?.forEach(timer => clearTimeout(timer));
        this.additions?.forEach(node => node.remove());
        this.classChanges?.forEach(([node, name]) => node.classList.remove(name));
        this.attributeChanges?.forEach(([node, name, value]) => {
          if (value === null) node.removeAttribute(name); else node.setAttribute(name, value);
        });
        this.styleChanges?.forEach(([node, value]) => {
          if (value) node.style.setProperty('--vh-menu-rows', value); else node.style.removeProperty('--vh-menu-rows');
        });
      }
    });
  }

  /* VOGALAB MOBILE MENU: deliberately independent of the existing desktop menu. */
  if (!customElements.get('vogalab-mobile-menu')) {
    customElements.define('vogalab-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.dialog = null;
        this.isOpen = false;
        this.stack = [];
        this.focusFrame = null;
        const start = () => {
          if (this.isConnected && !this.abort.signal.aborted) this.mount();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.abort.signal });
        } else {
          queueMicrotask(start);
        }
      }

      listen(target, name, callback, options = {}) {
        target.addEventListener(name, callback, { ...options, signal: this.abort.signal });
      }

      mount() {
        this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
        this.drawer = this.root?.querySelector('header-drawer');
        this.nativeDetails = this.drawer?.querySelector(':scope > details');
        this.opener = this.nativeDetails?.querySelector(':scope > summary');
        this.template = this.querySelector('template[data-vm-dialog-template]');
        // Old browsers, or a theme with a different header, retain the native drawer.
        if (!this.opener || !this.template || typeof HTMLDialogElement === 'undefined' ||
            typeof HTMLDialogElement.prototype.showModal !== 'function') return;

        this.mobile = window.matchMedia('(max-width: 989px)');
        this.originalAttributes = new Map(
          ['aria-controls', 'aria-haspopup', 'aria-expanded'].map(name => [name, this.opener.getAttribute(name)])
        );
        this.syncOpener();
        this.listen(this.root, 'click', event => {
          if (!this.mobile.matches || !(event.target instanceof Element)) return;
          if (event.target.closest('summary') !== this.opener) return;
          // If the shopper opened Dawn before this component initialized, let Dawn
          // finish its own close first. Do not leave two overlapping drawers open.
          if (this.nativeDetails.open && !this.isOpen) return;
          if (this.open()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true });

        this.listen(this.mobile, 'change', () => {
          if (!this.mobile.matches) {
            this.close(false);
            this.removeDialog();
          }
          this.syncOpener();
        });
        this.listen(window, 'pagehide', () => this.close(false));
        this.listen(window, 'pageshow', () => {
          if (!this.isOpen && this.dialog?.open) this.dialog.close();
        });
        this.listen(document, 'shopify:section:unload', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) {
            this.close(false);
            this.removeDialog();
          }
        });
      }

      syncOpener() {
        if (!this.opener) return;
        if (this.mobile?.matches) {
          // aria-controls is set only while the live dialog exists.
          // The original control target is retained before the first opening.
          this.opener.setAttribute('aria-haspopup', 'dialog');
          this.opener.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
        } else {
          this.restoreOpener();
        }
      }

      restoreOpener() {
        this.originalAttributes?.forEach((value, name) => {
          if (value === null) this.opener.removeAttribute(name);
          else this.opener.setAttribute(name, value);
        });
      }

      ensureDialog() {
        if (this.dialog?.isConnected) return true;
        const dialog = this.template.content.querySelector('dialog')?.cloneNode(true);
        if (!dialog) return false;
        this.dialog = dialog;
        // A modal in the browser's top layer is not clipped by sticky headers,
        // transforms, announcement bars or ordinary floating chat widgets.
        document.body.append(dialog);
        this.scrollArea = dialog.querySelector('[data-vm-scroll]');
        this.stage = dialog.querySelector('[data-vm-stage]');
        this.panels = new Map([['root', dialog.querySelector('[data-vm-screen="root"]')]]);
        this.panelTemplates = new Map(Array.from(dialog.querySelectorAll('template[data-vm-panel-template]'))
          .map(template => [template.dataset.vmPanelTemplate, template]));

        this.listen(dialog, 'click', event => {
          if (!(event.target instanceof Element)) return;
          const control = event.target.closest('[data-vm-close], [data-vm-back], [data-vm-next]');
          if (control) {
            event.preventDefault();
            event.stopPropagation();
            if (control.hasAttribute('data-vm-close')) this.close();
            else if (control.hasAttribute('data-vm-back')) this.back();
            else this.next(control.dataset.vmNext, control);
            return;
          }
          const anchor = event.target.closest('a[href]');
          if (anchor) {
            // Preserve regular links, modified clicks and the browser's navigation.
            // Also dismiss the menu for a valid same-page hash link.
            this.close(false);
          }
        });
        this.listen(dialog, 'submit', () => this.close(false));
        this.listen(dialog, 'cancel', event => {
          event.preventDefault();
          if (this.stack.length > 1) this.back();
          else this.close();
        });
        this.listen(dialog, 'close', () => {
          // Account for a browser-initiated close, but ignore a stale close event
          // if the shopper already reopened the same dialog.
          if (this.isOpen && !dialog.open) this.close();
        });
        return true;
      }

      open() {
        if (!this.mobile?.matches) return false;
        if (this.isOpen) return true;
        try {
          if (!this.ensureDialog()) return false;
          this.stack = [{ key: 'root', scroll: 0, trigger: null }];
          this.showPanel('root', '', 0);
          this.lockPage();
          this.dialog.showModal();
          this.isOpen = true;
          this.opener.setAttribute('aria-controls', this.dialog.id);
          this.opener.setAttribute('aria-expanded', 'true');
          // Do not focus the search input automatically: it opens the phone keyboard.
          this.focus(this.dialog.querySelector('[data-vm-close]'));
          return true;
        } catch (error) {
          this.isOpen = false;
          if (this.dialog?.open) this.dialog.close();
          this.unlockPage();
          console.warn('[VOGALAB mobile menu] Native menu retained.', error);
          return false;
        }
      }

      getPanel(key) {
        if (this.panels.has(key)) return this.panels.get(key);
        const panel = this.panelTemplates.get(key)?.content.firstElementChild?.cloneNode(true);
        if (!panel) return null;
        this.stage.append(panel);
        this.panels.set(key, panel);
        return panel;
      }

      next(key, trigger) {
        if (!this.isOpen || !this.getPanel(key)) return;
        const previous = this.stack[this.stack.length - 1];
        previous.scroll = this.scrollArea.scrollTop;
        previous.trigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        this.stack.push({ key, scroll: 0, trigger: null });
        this.showPanel(key, 'forward', 0);
        this.focus(this.panels.get(key).querySelector('[data-vm-back]'));
      }

      back() {
        if (!this.isOpen || this.stack.length < 2) return;
        this.stack.pop();
        const previous = this.stack[this.stack.length - 1];
        previous.trigger?.setAttribute('aria-expanded', 'false');
        this.showPanel(previous.key, 'back', previous.scroll);
        this.focus(previous.trigger || this.dialog.querySelector('[data-vm-close]'));
      }

      showPanel(key, motion, scroll) {
        const active = this.getPanel(key);
        if (!active) return;
        this.panels.forEach(panel => {
          panel.hidden = panel !== active;
          panel.inert = panel !== active;
          panel.removeAttribute('data-vm-motion');
        });
        this.dialog.dataset.vmLevel = key === 'root' ? 'root' : 'child';
        if (motion) {
          void active.offsetWidth;
          active.dataset.vmMotion = motion;
        }
        this.scrollArea.scrollTop = scroll;
      }

      focus(element) {
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = null;
          if (this.isOpen && element?.isConnected) element.focus({ preventScroll: true });
        });
      }

      rememberStyle(element, properties) {
        return properties.map(name => [element, name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]);
      }

      lockPage() {
        if (this.savedStyles) return;
        this.savedScroll = { x: window.scrollX, y: window.scrollY };
        this.savedStyles = [
          ...this.rememberStyle(document.documentElement, ['overflow', 'overscroll-behavior']),
          ...this.rememberStyle(document.body, ['position', 'top', 'left', 'width', 'overflow'])
        ];
        this.sticky = this.root.querySelector('sticky-header');
        if (this.sticky) {
          this.previousPreventHide = this.sticky.preventHide;
          this.sticky.preventHide = true;
        }
        document.documentElement.style.setProperty('overflow', 'hidden', 'important');
        document.documentElement.style.setProperty('overscroll-behavior', 'none', 'important');
        document.body.style.setProperty('position', 'fixed', 'important');
        document.body.style.setProperty('top', -this.savedScroll.y + 'px', 'important');
        document.body.style.setProperty('left', -this.savedScroll.x + 'px', 'important');
        document.body.style.setProperty('width', '100%', 'important');
        document.body.style.setProperty('overflow', 'hidden', 'important');
      }

      unlockPage() {
        if (!this.savedStyles) return;
        const html = document.documentElement;
        const behavior = html.style.getPropertyValue('scroll-behavior');
        const priority = html.style.getPropertyPriority('scroll-behavior');
        html.style.setProperty('scroll-behavior', 'auto', 'important');
        this.savedStyles.forEach(([element, name, value, oldPriority]) => {
          if (value) element.style.setProperty(name, value, oldPriority);
          else element.style.removeProperty(name);
        });
        this.savedStyles = null;
        window.scrollTo(this.savedScroll.x, this.savedScroll.y);
        if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
        else html.style.removeProperty('scroll-behavior');
        if (this.sticky) this.sticky.preventHide = this.previousPreventHide;
      }

      close(restoreFocus = true) {
        if (!this.isOpen && !this.savedStyles) return;
        this.isOpen = false;
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = null;
        if (this.dialog?.open) this.dialog.close();
        this.unlockPage();
        this.dialog?.querySelectorAll('[data-vm-next]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.opener?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.mobile?.matches && this.opener?.isConnected) {
          this.opener.focus({ preventScroll: true });
        } else if (this.mobile && !this.mobile.matches && this.root?.isConnected) {
          this.root.querySelector('.header__heading-link')?.focus({ preventScroll: true });
        }
      }

      removeDialog() {
        this.dialog?.remove();
        this.dialog = null;
        this.panels?.clear();
        this.panelTemplates?.clear();
        this.stack = [];
      }

      disconnectedCallback() {
        this.close(false);
        this.abort?.abort();
        this.removeDialog();
        this.restoreOpener();
        cancelAnimationFrame(this.focusFrame);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jiao2"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-edu-courses';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   
   
const cards=[...this.querySelectorAll('[data-course]')],select=this.querySelector('select[data-subject]');
// These scroll helpers run only at the same mobile breakpoint as the CSS.
// Native touch scrolling remains in charge; no touchmove interception.
const track=this.querySelector('.vg-course-grid');
const mobile=window.matchMedia('(max-width: 749px)');
const resetMobileRail=()=>{
 if(track && mobile.matches)track.scrollTo({left:0,behavior:'auto'});
};
const revealMobileCard=card=>{
 if(!track || !mobile.matches || !card || card.hidden)return;
 const railRect=track.getBoundingClientRect(),cardRect=card.getBoundingClientRect();
 const style=getComputedStyle(track);
 const rtl=style.direction==='rtl';
 const gap=rtl
  ? cardRect.right-railRect.right+track.clientLeft+(parseFloat(style.paddingRight)||0)
  : cardRect.left-railRect.left-track.clientLeft-(parseFloat(style.paddingLeft)||0);
 track.scrollBy({left:gap,behavior:'auto'});
};
while(select.options.length>1)select.remove(1);
const subjects=[...new Set(cards.map(c=>c.dataset.subject).filter(Boolean))];
subjects.forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;select.append(o);});
let grade='all';
const filter=()=>{
 let count=0;cards.forEach(c=>{const match=(grade==='all'||c.dataset.grade==='all'||c.dataset.grade===grade)&&(!select.value||c.dataset.subject===select.value);c.hidden=!match;if(match)count++;});
 this.querySelector('[data-empty]').hidden=count>0;
 this.querySelector('[data-count]').textContent=count+' '+this.dataset.countSuffix;
 resetMobileRail();
};
this.on(this,'click',e=>{const b=e.target.closest('button[data-grade]');if(!b)return;grade=b.dataset.grade;this.querySelectorAll('button[data-grade]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter();});
this.on(select,'change',filter);
this.on(this,'shopify:block:select',e=>{const card=e.target.closest('[data-course]');if(card){grade='all';select.value='';this.querySelectorAll('button[data-grade]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.grade==='all')));filter();revealMobileCard(card);}});
filter();

  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());}
  
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jiao3"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-edu-syllabus';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   this.setupTabs();
   
  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());}
  
setupTabs(){
 const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];
 if(!tabs.length)return;
 const activate=index=>{
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
  panels.forEach((panel,i)=>panel.hidden=i!==index);
  this.dispatchEvent(new Event('vg:layout'));
 };
 this.on(this,'click',e=>{const t=e.target.closest('[data-tab]');if(t)activate(tabs.indexOf(t));});
 this.on(this,'keydown',e=>{
  const t=e.target.closest('[data-tab]');if(!t)return;
  let i=tabs.indexOf(t),n=i;
  if(['ArrowRight','ArrowDown'].includes(e.key))n=(i+1)%tabs.length;
  else if(['ArrowLeft','ArrowUp'].includes(e.key))n=(i-1+tabs.length)%tabs.length;
  else if(e.key==='Home')n=0;
  else if(e.key==='End')n=tabs.length-1;
  else return;
  e.preventDefault();activate(n);tabs[n].focus();
 });
 this.on(this,'shopify:block:select',e=>{
  const id=e.detail&&e.detail.blockId;
  const index=tabs.findIndex(t=>t.dataset.blockId===id);
  if(index>=0)activate(index);
 });
 activate(Math.min(Math.max(Number(this.dataset.initial||1)-1,0),tabs.length-1));
}

 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jiao4"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-edu-classroom';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   this.setupVideos();
   
  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());this.stopVideos();}
  
setupVideos(){
 this.on(this,'click',e=>{
  const trigger=e.target.closest('[data-play]');
  if(!trigger||trigger.disabled)return;
  const player=trigger.closest('[data-player]');
  this.stopVideos();
  const host=player.querySelector('[data-video-host]');
  const template=player.querySelector('template[data-hosted-video]');
  if(template){
   host.append(template.content.cloneNode(true));
   const video=host.querySelector('video');
   if(!video)return;
   video.controls=true;video.loop=false;video.muted=false;video.playsInline=true;
   host.hidden=false;trigger.hidden=true;
   video.play().catch(()=>{});video.focus();
  }else{
   const provider=trigger.dataset.provider,id=trigger.dataset.videoId;
   if(!id||!['youtube','vimeo'].includes(provider))return;
   const frame=document.createElement('iframe');
   frame.src=provider==='youtube'?'https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0':'https://player.vimeo.com/video/'+encodeURIComponent(id)+'?autoplay=1&dnt=1';
   frame.title=trigger.getAttribute('aria-label')||'Video';
   frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
   frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
   host.append(frame);host.hidden=false;trigger.hidden=true;frame.focus();
  }
 });
}
stopVideos(){
 this.querySelectorAll('[data-player]').forEach(player=>{
  const host=player.querySelector('[data-video-host]');
  host.querySelectorAll('video').forEach(v=>v.pause());
  host.replaceChildren();host.hidden=true;
  player.querySelector('[data-play]').hidden=false;
 });
}

 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ke4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vg-course-check')) return;
    customElements.define('vg-course-check', class extends HTMLElement {
      connectedCallback() {
        if (this._vg04Bound) return;
        this._vg04Bound = true;
        this._vg04Button = this.querySelector('[data-vg04-print]');
        this._vg04Status = this.querySelector('[data-vg04-status]');
        this._vg04OnPrint = () => this._vg04Print();
        if (this._vg04Button) {
          this._vg04Button.hidden = false;
          this._vg04Button.addEventListener('click', this._vg04OnPrint);
        }
      }
      disconnectedCallback() {
        if (this._vg04Button) this._vg04Button.removeEventListener('click', this._vg04OnPrint);
        this._vg04Cleanup();
        this._vg04Bound = false;
      }
      _vg04Announce(message) {
        if (!this._vg04Status) return;
        this._vg04Status.textContent = message || '';
        this._vg04Status.hidden = !message;
      }
      _vg04Cleanup() {
        if (this._vg04CancelImages) this._vg04CancelImages();
        this._vg04CancelImages = null;
        if (this._vg04Frame) this._vg04Frame.remove();
        this._vg04Frame = null;
        clearTimeout(this._vg04RemovalTimer);
        this._vg04RemovalTimer = null;
        if (this._vg04Button) this._vg04Button.disabled = false;
        this._vg04Printing = false;
      }
      _vg04ImagesReady(doc) {
        return new Promise(resolve => {
          const images = Array.from(doc.images);
          const listeners = [];
          let remaining = images.length;
          let timer;
          let settled = false;
          const finish = ready => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            listeners.forEach(([img, fn]) => {
              img.removeEventListener('load', fn);
              img.removeEventListener('error', fn);
            });
            this._vg04CancelImages = null;
            resolve(ready);
          };
          this._vg04CancelImages = () => finish(false);
          const done = () => { remaining -= 1; if (!remaining) finish(true); };
          images.forEach(img => {
            img.loading = 'eager';
            if (img.complete) done();
            else {
              const onReady = () => {
                img.removeEventListener('load', onReady);
                img.removeEventListener('error', onReady);
                done();
              };
              listeners.push([img, onReady]);
              img.addEventListener('load', onReady);
              img.addEventListener('error', onReady);
            }
          });
          if (!remaining) finish(true);
          if (!settled) timer = setTimeout(() => finish(true), 3000);
        });
      }
      async _vg04Print() {
        if (this._vg04Printing) return;
        this._vg04Cleanup();
        this._vg04Printing = true;
        this._vg04Button.disabled = true;
        this._vg04Announce(this.dataset.printPreparing);
        let frame;
        try {
          frame = document.createElement('iframe');
          this._vg04Frame = frame;
          frame.title = this.dataset.printFrameLabel || this.dataset.printTitle || '';
          frame.setAttribute('aria-hidden', 'true');
          frame.tabIndex = -1;
          frame.style.cssText = 'position:fixed;left:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';
          document.body.appendChild(frame);
          const printDoc = frame.contentDocument;
          if (!printDoc || !frame.contentWindow) throw new Error('Print view unavailable');
          // Build the print document with DOM nodes, without parsing an HTML string.
          const printRoot = printDoc.createElement('html');
          const printHead = printDoc.createElement('head');
          const printBody = printDoc.createElement('body');
          const charset = printDoc.createElement('meta');
          charset.setAttribute('charset', 'utf-8');
          const viewport = printDoc.createElement('meta');
          viewport.name = 'viewport';
          viewport.content = 'width=device-width,initial-scale=1';
          printHead.append(charset, viewport);
          printRoot.append(printHead, printBody);
          while (printDoc.firstChild) printDoc.removeChild(printDoc.firstChild);
          printDoc.appendChild(printDoc.implementation.createDocumentType('html', '', ''));
          printDoc.appendChild(printRoot);
          printDoc.documentElement.lang = document.documentElement.lang || 'en';
          const base = printDoc.createElement('base');
          base.href = document.baseURI;
          printDoc.head.appendChild(base);
          const title = printDoc.createElement('title');
          title.textContent = this.dataset.printTitle || '';
          printDoc.head.appendChild(title);

          // Clone the record into a separate document; never hide the storefront.
          const copy = this.cloneNode(true);
          copy.querySelectorAll('[data-vg04-print], [data-vg04-status], script, .vg04-image-placeholder').forEach(node => node.remove());
          const originals = this.querySelectorAll('input, textarea');
          copy.querySelectorAll('input, textarea').forEach((field, index) => {
            const original = originals[index];
            if (!original) return;
            if (field.tagName === 'TEXTAREA') {
              const answer = printDoc.createElement('div');
              answer.className = 'vg04-print-answer';
              answer.id = field.id;
              answer.textContent = original.value;
              field.replaceWith(answer);
            } else {
              field.checked = original.checked;
              field.toggleAttribute('checked', original.checked);
            }
          });
          printDoc.body.style.margin = '18px';
          printDoc.body.appendChild(printDoc.adoptNode(copy));
          const ready = await this._vg04ImagesReady(printDoc);
          if (!ready || !this.isConnected || this._vg04Frame !== frame) return;
          const printWindow = frame.contentWindow;
          // afterprint cleans up the temporary document even when the dialog is cancelled.
          printWindow.addEventListener('afterprint', () => {
            if (this._vg04Frame !== frame) return;
            this._vg04Announce(this.dataset.printOpened);
            this._vg04Cleanup();
            if (this.isConnected && this._vg04Button) this._vg04Button.focus({ preventScroll: true });
          }, { once: true });
          this._vg04Announce(this.dataset.printOpened);
          printWindow.focus();
          printWindow.print();
          if (this._vg04Frame === frame) {
            // Fallback for engines that do not dispatch afterprint. The frame contains no stored data.
            this._vg04RemovalTimer = setTimeout(() => this._vg04Cleanup(), 60000);
          }
        } catch (_) {
          this._vg04Cleanup();
          this._vg04Announce(this.dataset.printError);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vogalab-build-story"] && !Shopify.designMode) return;
  try {
    

(() => {

  const tag = 'vogalab-watch-kids-build-mixed-v5';

  if (customElements.get(tag)) return;

  class VogalabWatchKidsBuildV2 extends HTMLElement {

    connectedCallback() {

      if (this._ready) return;

      this._ready = true;

      this._connectedFrame = requestAnimationFrame(() => {

        if (!this.isConnected) return;

        this._init();

      });

    }

    _init() {

      this._abort?.abort();

      this._abort = new AbortController();

      const signal = this._abort.signal;

      this._rail = this.querySelector('[data-rail]');

      this._prev = this.querySelector('[data-rail-prev]');

      this._next = this.querySelector('[data-rail-next]');

      this._controls = this.querySelector('[data-rail-controls]');

      this._cards = Array.from(this.querySelectorAll('[data-card]'));

      this._slides = this._rail ? Array.from(this._rail.querySelectorAll('[data-card]')) : [];

      this._cards.forEach(card => {

        card.querySelector('[data-play]')?.addEventListener('click', () => this._playCard(card), { signal });

      });

      if (this._rail) {

        this._prev.addEventListener('click', () => this._step(-1), { signal });

        this._next.addEventListener('click', () => this._step(1), { signal });

        this._rail.addEventListener('scroll', () => this._scheduleNavigation(), { passive: true, signal });

        this._rail.addEventListener('keydown', event => {

          if (event.target !== this._rail) return;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {

            event.preventDefault();

            this._step(event.key === 'ArrowLeft' ? -1 : 1);

          } else if (event.key === 'Home' || event.key === 'End') {

            event.preventDefault();

            this._moveRail(event.key === 'Home' ? 0 : this._rail.scrollWidth);

          }

        }, { signal });

        this._bindMouseDrag(signal);

        if ('ResizeObserver' in window) {

          this._resize = new ResizeObserver(() => this._scheduleNavigation());

          this._resize.observe(this._rail);

        } else {

          window.addEventListener('resize', () => this._scheduleNavigation(), { passive: true, signal });

        }

        this._updateNavigation();

      }

      this._dialog = this.querySelector('[data-instagram-dialog]');
      this._player = this.querySelector('[data-instagram-player]');
      this._dialog.querySelector('[data-dialog-close]').addEventListener('click', () => this._dialog.close(), { signal });
      this._dialog.addEventListener('close', () => { if (!this._dialog.open) this._cleanupPlayer(); }, { signal });
      this._dialog.addEventListener('click', event => {
        const box = this._dialog.getBoundingClientRect();
        if (event.target === this._dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this._dialog.close();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this._dialog.open) this._dialog.close();
      }, { signal });
      document.addEventListener('vkb:instagram-open', event => {
        if (event.detail !== this && this._dialog.open) this._dialog.close();
      }, { signal });
      this.addEventListener('shopify:section:unload', () => {
        if (this._dialog.open) this._dialog.close();
        this._cleanupPlayer();
      }, { signal });

      // Preserve the editor block identity; selecting card 4+ reveals it horizontally.

      this.addEventListener('shopify:block:select', event => {

        const id = event.detail?.blockId;

        const card = this._cards.find(item => item.dataset.blockId === id);

        if (!card || !this._rail?.contains(card)) return;

        const box = card.getBoundingClientRect();

        const railBox = this._rail.getBoundingClientRect();

        this._moveRail(this._rail.scrollLeft + box.left - railBox.left - 3, true);

      }, { signal });

    }

    _scheduleNavigation() {

      if (this._navFrame) return;

      this._navFrame = requestAnimationFrame(() => {

        this._navFrame = 0;

        this._updateNavigation();

      });

    }

    _updateNavigation() {

      if (!this._rail) return;

      const max = Math.max(0, this._rail.scrollWidth - this._rail.clientWidth);

      const left = Math.max(0, this._rail.scrollLeft);

      this._controls.hidden = max <= 2;

      this._prev.disabled = left <= 2;

      this._next.disabled = left >= max - 2;

    }

    _positions() {

      if (!this._rail) return [];

      const box = this._rail.getBoundingClientRect();

      const max = this._rail.scrollWidth - this._rail.clientWidth;

      const targets = this._slides.map(card => {

        const left = this._rail.scrollLeft + card.getBoundingClientRect().left - box.left - 3;

        return Math.max(0, Math.min(max, left));

      });

      return [...new Set([0, ...targets, Math.max(0, max)])].sort((a, b) => a - b);

    }

    _step(direction) {

      const current = this._rail.scrollLeft;

      const positions = this._positions();

      const target = direction > 0

        ? positions.find(position => position > current + 4)

        : positions.reverse().find(position => position < current - 4);

      this._moveRail(target ?? current);

    }

    _moveRail(left, immediate = false) {

      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._rail?.scrollTo({ left, behavior: immediate || reduced ? 'auto' : 'smooth' });

    }

    _bindMouseDrag(signal) {

      const rail = this._rail;

      rail.addEventListener('pointerdown', event => {

        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        if (event.target.closest('button,video,a,input,select,textarea')) return;

        this._drag = { id: event.pointerId, x: event.clientX, left: rail.scrollLeft, moved: false };

      }, { signal });

      rail.addEventListener('pointermove', event => {

        const drag = this._drag;

        if (!drag || event.pointerId !== drag.id) return;

        const delta = event.clientX - drag.x;

        if (!drag.moved && Math.abs(delta) < 6) return;

        if (!drag.moved) {

          drag.moved = true;

          rail.classList.add('is-dragging');

          rail.setPointerCapture(event.pointerId);

        }

        event.preventDefault();

        rail.scrollLeft = drag.left - delta;

      }, { signal });

      const finish = event => {

        const drag = this._drag;

        if (!drag || event.pointerId !== drag.id) return;

        this._drag = null;

        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);

        rail.classList.remove('is-dragging');

        this._scheduleNavigation();

      };

      rail.addEventListener('pointerup', finish, { signal });

      rail.addEventListener('pointercancel', finish, { signal });

      rail.addEventListener('lostpointercapture', finish, { signal });

      rail.addEventListener('pointerleave', event => {

        if (this._drag && !this._drag.moved) finish(event);

      }, { signal });

    }

    _message(card, text) {

      const node = card.querySelector('[data-video-message]');

      if (!node) return;

      node.textContent = text;

      node.hidden = !text;

    }

    _instagramLink(value) {
      try {
        const url = new URL(String(value).trim());
        if (url.protocol !== 'https:' || !['instagram.com','www.instagram.com','m.instagram.com'].includes(url.hostname) || url.username || url.password || url.port) return null;
        const match = url.pathname.match(/^\/(reel|reels|p|tv)\/([A-Za-z0-9_-]+)\/?$/);
        if (!match) return null;
        const type = match[1] === 'reels' ? 'reel' : match[1];
        const canonical = `https://www.instagram.com/${type}/${match[2]}/`;
        return { canonical, embed: `${canonical}embed/` };
      } catch { return null; }
    }

    _youtubeLink(value) {
      try {
        const url = new URL(String(value).trim());
        if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
        const host = url.hostname.toLowerCase();
        let id = '';
        if (host === 'youtu.be' || host === 'www.youtu.be') {
          const match = url.pathname.match(/^\/([A-Za-z0-9_-]{11})\/?$/);
          id = match?.[1] || '';
        } else if (['youtube.com','www.youtube.com','m.youtube.com','youtube-nocookie.com','www.youtube-nocookie.com'].includes(host)) {
          if (url.pathname === '/watch') id = url.searchParams.get('v') || '';
          else id = url.pathname.match(/^\/(?:embed|shorts|live)\/([A-Za-z0-9_-]{11})\/?$/)?.[1] || '';
        }
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return null;
        return {
          canonical:`https://www.youtube.com/watch?v=${id}`,
          embed:`https://www.youtube-nocookie.com/embed/${id}?autoplay=0&playsinline=1&controls=1&rel=0`
        };
      } catch { return null; }
    }

    _cleanupPlayer() {
      clearTimeout(this._loadTimer);
      this._loadTimer = 0;
      this._embedObserver?.disconnect();
      this._embedObserver = null;
      this._player?.replaceChildren(); // Remove iframe: stops audio/video even across origins.
      if (this._scrollLocked) {
        document.body.style.overflow = this._oldOverflow;
        this._scrollLocked = false;
      }
      const opener = this._opener;
      this._opener = null;
      if (opener?.isConnected) opener.focus({ preventScroll:true });
    }

    _loadInstagramScript() {
      if (window.instgrm?.Embeds?.process) return Promise.resolve();
      // Keep one request across section instances and theme-editor reloads.
      if (window.vogalabInstagramLoader) return window.vogalabInstagramLoader;
      window.vogalabInstagramLoader = new Promise((resolve, reject) => {
        let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
        let timer;
        const cleanup = () => { clearTimeout(timer); script.removeEventListener('load', loaded); script.removeEventListener('error', failed); };
        const loaded = () => { cleanup(); if (window.instgrm?.Embeds?.process) resolve(); else reject(new Error('Instagram embed unavailable')); };
        const failed = () => { cleanup(); reject(new Error('Instagram script blocked')); };
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://www.instagram.com/embed.js';
          script.async = true;
          script.dataset.vogalabInstagram = 'true';
        }
        script.addEventListener('load', loaded, { once:true });
        script.addEventListener('error', failed, { once:true });
        timer = setTimeout(failed, 12000);
        if (!script.isConnected) document.head.append(script);
      }).catch(error => {
        const own = document.querySelector('script[data-vogalab-instagram="true"]');
        own?.remove();
        window.vogalabInstagramLoader = null;
        throw error;
      });
      return window.vogalabInstagramLoader;
    }

    _mountInstagram(link, status) {
      const block = document.createElement('blockquote');
      block.className = 'instagram-media';
      block.setAttribute('data-instgrm-permalink', link.canonical);
      block.setAttribute('data-instgrm-version', '14');
      const fallback = document.createElement('a');
      fallback.href = link.canonical;
      fallback.target = '_blank';
      fallback.rel = 'noopener noreferrer';
      fallback.textContent = 'View this video on Instagram';
      block.append(fallback);
      this._player.append(block);
      const player = this._player;
      this._embedObserver = new MutationObserver(() => {
        const frames = player.querySelectorAll('iframe');
        frames.forEach(frame => {
          frame.setAttribute('allow', "autoplay 'none'; fullscreen; encrypted-media");
          frame.removeAttribute('autoplay');
          frame.title = 'Instagram video';
        });
        if (frames.length) {
          clearTimeout(this._loadTimer);
          status.hidden = true;
        }
      });
      this._embedObserver.observe(player, { childList:true, subtree:true });
      this._loadTimer = setTimeout(() => {
        if (this._dialog.open && block.isConnected) {
          status.hidden = false;
          status.textContent = 'Instagram may require login or embedding permission. Use the link below.';
        }
      }, 15000);
      this._loadInstagramScript().then(() => {
        if (!this.isConnected || !this._dialog.open || !player.contains(block)) return;
        window.instgrm.Embeds.process();
      }).catch(() => {
        if (!this.isConnected || !this._dialog.open || !player.contains(block)) return;
        clearTimeout(this._loadTimer);
        status.hidden = false;
        status.textContent = 'Instagram could not load. Open the video with the link below.';
      });
    }

    _playCard(card) {
      const isYouTube = card.dataset.provider === 'youtube';
      const link = isYouTube ? this._youtubeLink(card.dataset.videoUrl) : this._instagramLink(card.dataset.videoUrl);
      if (!link) {
        this._message(card, isYouTube ? 'Use a valid YouTube video link for this 16:9 card.' : 'Use a public Instagram Reel or post link.');
        return;
      }
      if (typeof this._dialog.showModal !== 'function') {
        window.open(link.canonical, '_blank', 'noopener,noreferrer');
        return;
      }
      document.dispatchEvent(new CustomEvent('vkb:instagram-open', { detail:this }));
      if (this._dialog.open) this._dialog.close();
      this._cleanupPlayer();
      this._message(card, '');
      this._dialog.classList.toggle('is-youtube', isYouTube);
      this._opener = card.querySelector('[data-play]');
      this._dialog.querySelector('[data-dialog-title]').textContent = card.querySelector('.vkb__sticker')?.textContent.trim() || 'Watch video';
      const original = this._dialog.querySelector('[data-instagram-original]');
      original.href = link.canonical;
      original.textContent = isYouTube ? 'open it on YouTube' : 'open it on Instagram';
      const status = this._dialog.querySelector('[data-dialog-status]');
      status.hidden = false;
      status.textContent = 'Loading video…';
      if (!isYouTube) {
        this._oldOverflow = document.body.style.overflow;
        this._scrollLocked = true;
        document.body.style.overflow = 'hidden';
        try { this._dialog.showModal(); }
        catch { this._cleanupPlayer(); return; }
        this._mountInstagram(link, status);
        return;
      }
      const frame = document.createElement('iframe');
      frame.title = isYouTube ? 'YouTube video' : 'Instagram video';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      // Explicitly deny autoplay. No autoplay query and no play() call.
      frame.setAttribute('allow', "autoplay 'none'; fullscreen; encrypted-media");
      frame.allowFullscreen = true;
      frame.addEventListener('load', () => {
        if (frame.parentNode === this._player) {
          clearTimeout(this._loadTimer);
          status.hidden = true;
        }
      }, { once:true });
      frame.addEventListener('error', () => {
        status.hidden = false;
        status.textContent = `Unable to load the player. Use the ${isYouTube ? 'YouTube' : 'Instagram'} link below.`;
      }, { once:true });
      frame.src = link.embed; // Assign src only in the user click handler.
      this._player.append(frame);
      this._oldOverflow = document.body.style.overflow;
      this._scrollLocked = true;
      document.body.style.overflow = 'hidden';
      try { this._dialog.showModal(); }
      catch { this._cleanupPlayer(); return; }
      this._loadTimer = setTimeout(() => {
        if (this._dialog.open && frame.parentNode === this._player) {
          status.hidden = false;
          status.textContent = `Taking longer to load? Open the video on ${isYouTube ? 'YouTube' : 'Instagram'} below.`;
        }
      }, 12000);
    }

    disconnectedCallback() {

      if (this._dialog?.open) this._dialog.close();
      this._cleanupPlayer();

      this._abort?.abort();

      this._resize?.disconnect();

      cancelAnimationFrame(this._connectedFrame);

      cancelAnimationFrame(this._navFrame);

      this._rail?.classList.remove('is-dragging');

      this._drag = null;

      this._navFrame = 0;

      this._ready = false;

    }

  }

  customElements.define(tag, VogalabWatchKidsBuildV2);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xue2"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-kids-projects';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   this.setupSliders();this.setupBookmarks();
   
const channel=this.dataset.channel,cards=[...this.querySelectorAll('[data-project]')];
let query='',category='all';
const apply=()=>{
 const words=query.toLowerCase().trim().split(/\s+/).filter(Boolean);let count=0;
 cards.forEach(card=>{
  const match=(category==='all'||card.dataset.category===category)&&words.every(w=>card.dataset.search.toLowerCase().includes(w));
  card.hidden=!match;if(match)count++;
 });
 this.querySelector('[data-empty]').hidden=count>0;this.querySelector('[data-count]').textContent=count+' '+this.dataset.countSuffix;
 const track=this.querySelector('[data-track]');track.scrollLeft=0;this.dispatchEvent(new Event('vg:layout'));
 this.querySelectorAll('button[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
};
this.on(window,'vogalab:hub-filter',e=>{if(e.detail?.channel!==channel)return;query=e.detail.query||'';category=e.detail.category||'all';apply();});
const local=this.querySelector('[data-local-search]');
if(local)this.on(local,'input',()=>{query=local.value;apply();});
this.on(this,'click',e=>{const b=e.target.closest('button[data-category]');if(b){category=b.dataset.category;apply();}});
this.on(this,'shopify:block:select',e=>{const card=e.target.closest('[data-project]');if(card){query='';category='all';if(local)local.value='';apply();card.scrollIntoView({block:'nearest',inline:'center'});}});
apply();queueMicrotask(()=>window.dispatchEvent(new CustomEvent('vogalab:hub-request',{detail:{channel}})));

  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());}
  
setupSliders(){
 this.querySelectorAll('[data-slider-group]').forEach(group=>{
  const track=group.querySelector('[data-track]'),prev=group.querySelector('[data-prev]'),next=group.querySelector('[data-next]');
  if(!track||!prev||!next)return;
  const update=()=>{
   const end=Math.max(0,track.scrollWidth-track.clientWidth);
   prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=end-2;
   group.querySelector('[data-slider-controls]').hidden=end<3;
  };
  const move=direction=>track.scrollBy({left:direction*track.clientWidth*.88,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  this.on(prev,'click',()=>move(-1));this.on(next,'click',()=>move(1));
  this.on(track,'scroll',update);
  if('ResizeObserver' in window){const obs=new ResizeObserver(update);obs.observe(track);this.observers.push(obs);}
  this.on(this,'vg:layout',update);update();
 });
}

setupBookmarks(){
 const key='vogalab.saved-projects.v1';
 let saved=[];
 const read=()=>{try{const parsed=JSON.parse(localStorage.getItem(key)||'[]');saved=Array.isArray(parsed)?parsed:[];}catch{}};
 const update=()=>this.querySelectorAll('[data-save]').forEach(b=>{
  const active=saved.includes(b.dataset.save);
  b.setAttribute('aria-pressed',String(active));
  b.setAttribute('aria-label',(active?this.dataset.unsaveLabel:this.dataset.saveLabel)|| (active?'Remove saved project':'Save project'));
 });
 read();update();
 this.on(this,'click',e=>{
  const b=e.target.closest('[data-save]');if(!b)return;
  const id=b.dataset.save;if(!id)return;
  saved=saved.includes(id)?saved.filter(x=>x!==id):[...saved,id];
  try{localStorage.setItem(key,JSON.stringify(saved));}catch{}
  window.dispatchEvent(new CustomEvent('vogalab:bookmarks',{detail:{saved}}));update();
 });
 this.on(window,'vogalab:bookmarks',e=>{saved=Array.isArray(e.detail.saved)?e.detail.saved:[];update();});
 this.on(window,'storage',e=>{if(e.key===key){read();update();}});
}

 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xue3"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-kids-guide';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   this.setupTabs();
   
this.on(window,'vogalab:open-guide',e=>{
 if(e.detail?.channel!==this.dataset.channel)return;
 const tabs=[...this.querySelectorAll('[data-tab]')];
 const tab=tabs.find(t=>t.dataset.stepKey===e.detail.key);
 if(tab){tab.click();tab.scrollIntoView({block:'nearest',inline:'nearest'});}
});

  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());}
  
setupTabs(){
 const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];
 if(!tabs.length)return;
 const activate=index=>{
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
  panels.forEach((panel,i)=>panel.hidden=i!==index);
  this.dispatchEvent(new Event('vg:layout'));
 };
 this.on(this,'click',e=>{const t=e.target.closest('[data-tab]');if(t)activate(tabs.indexOf(t));});
 this.on(this,'keydown',e=>{
  const t=e.target.closest('[data-tab]');if(!t)return;
  let i=tabs.indexOf(t),n=i;
  if(['ArrowRight','ArrowDown'].includes(e.key))n=(i+1)%tabs.length;
  else if(['ArrowLeft','ArrowUp'].includes(e.key))n=(i-1+tabs.length)%tabs.length;
  else if(e.key==='Home')n=0;
  else if(e.key==='End')n=tabs.length-1;
  else return;
  e.preventDefault();activate(n);tabs[n].focus();
 });
 this.on(this,'shopify:block:select',e=>{
  const id=e.detail&&e.detail.blockId;
  const index=tabs.findIndex(t=>t.dataset.blockId===id);
  if(index>=0)activate(index);
 });
 activate(Math.min(Math.max(Number(this.dataset.initial||1)-1,0),tabs.length-1));
}

 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xue4"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-kids-skills';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   this.setupVideos();this.setupSliders();
   
const cards=[...this.querySelectorAll('[data-skill]')];
this.on(window,'vogalab:hub-filter',e=>{
 if(e.detail?.channel!==this.dataset.channel)return;
 const words=(e.detail.query||'').toLowerCase().trim().split(/\s+/).filter(Boolean);let count=0;
 this.stopVideos();
 cards.forEach(card=>{const match=words.every(w=>card.dataset.search.toLowerCase().includes(w));card.hidden=!match;if(match)count++;});
 this.querySelector('[data-empty]').hidden=count>0;this.querySelector('[data-track]').scrollLeft=0;this.dispatchEvent(new Event('vg:layout'));
});
queueMicrotask(()=>window.dispatchEvent(new CustomEvent('vogalab:hub-request',{detail:{channel:this.dataset.channel}})));

  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());this.stopVideos();}
  
setupVideos(){
 this.on(this,'click',e=>{
  const trigger=e.target.closest('[data-play]');
  if(!trigger||trigger.disabled)return;
  const player=trigger.closest('[data-player]');
  this.stopVideos();
  const host=player.querySelector('[data-video-host]');
  const template=player.querySelector('template[data-hosted-video]');
  if(template){
   host.append(template.content.cloneNode(true));
   const video=host.querySelector('video');
   if(!video)return;
   video.controls=true;video.loop=false;video.muted=false;video.playsInline=true;
   host.hidden=false;trigger.hidden=true;
   video.play().catch(()=>{});video.focus();
  }else{
   const provider=trigger.dataset.provider,id=trigger.dataset.videoId;
   if(!id||!['youtube','vimeo'].includes(provider))return;
   const frame=document.createElement('iframe');
   frame.src=provider==='youtube'?'https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0':'https://player.vimeo.com/video/'+encodeURIComponent(id)+'?autoplay=1&dnt=1';
   frame.title=trigger.getAttribute('aria-label')||'Video';
   frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
   frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
   host.append(frame);host.hidden=false;trigger.hidden=true;frame.focus();
  }
 });
}
stopVideos(){
 this.querySelectorAll('[data-player]').forEach(player=>{
  const host=player.querySelector('[data-video-host]');
  host.querySelectorAll('video').forEach(v=>v.pause());
  host.replaceChildren();host.hidden=true;
  player.querySelector('[data-play]').hidden=false;
 });
}

setupSliders(){
 this.querySelectorAll('[data-slider-group]').forEach(group=>{
  const track=group.querySelector('[data-track]'),prev=group.querySelector('[data-prev]'),next=group.querySelector('[data-next]');
  if(!track||!prev||!next)return;
  const update=()=>{
   const end=Math.max(0,track.scrollWidth-track.clientWidth);
   prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=end-2;
   group.querySelector('[data-slider-controls]').hidden=end<3;
  };
  const move=direction=>track.scrollBy({left:direction*track.clientWidth*.88,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  this.on(prev,'click',()=>move(-1));this.on(next,'click',()=>move(1));
  this.on(track,'scroll',update);
  if('ResizeObserver' in window){const obs=new ResizeObserver(update);obs.observe(track);this.observers.push(obs);}
  this.on(this,'vg:layout',update);update();
 });
}

 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xue5"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const tag='vg-kids-help';
 if(customElements.get(tag))return;
 customElements.define(tag,class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();this.observers=[];
   
   
const faqs=[...this.querySelectorAll('[data-faq]')];
faqs.forEach(d=>this.on(d,'toggle',()=>{
 if(d.open&&this.dataset.singleOpen==='true')faqs.forEach(other=>{if(other!==d)other.open=false;});
}));
const ideas=[...this.querySelectorAll('[data-idea]')],build=this.querySelector('[data-idea-build]'),audience=this.querySelector('[data-idea-audience]'),output=this.querySelector('[data-idea-output]');
let current=null;
const setOptions=(select,values)=>{select.replaceChildren();[...new Set(values)].forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;select.append(o);});};
const render=idea=>{
 if(!idea)return;current=idea;output.replaceChildren(...[...idea.children].map(n=>n.cloneNode(true)));
};
const pickForBuild=()=>{
 const options=ideas.filter(i=>i.dataset.build===build.value),previous=audience.value;
 setOptions(audience,options.map(i=>i.dataset.audience));
 if(options.some(i=>i.dataset.audience===previous))audience.value=previous;
 render(options.find(i=>i.dataset.audience===audience.value));
};
const selectIdea=idea=>{
 build.value=idea.dataset.build;pickForBuild();audience.value=idea.dataset.audience;render(idea);
};
if(ideas.length){
 setOptions(build,ideas.map(i=>i.dataset.build));pickForBuild();
 this.on(build,'change',pickForBuild);
 this.on(audience,'change',()=>render(ideas.find(i=>i.dataset.build===build.value&&i.dataset.audience===audience.value)));
 const random=this.querySelector('[data-idea-random]');random.disabled=ideas.length<2;
 this.on(random,'click',()=>{const options=ideas.filter(i=>i!==current);if(options.length)selectIdea(options[Math.floor(Math.random()*options.length)]);});
}
this.on(this,'shopify:block:select',e=>{
 const faq=e.target.closest('[data-faq]');if(faq)faq.open=true;
 const idea=ideas.find(i=>i.dataset.blockId===e.detail?.blockId);if(idea)selectIdea(idea);
});
this.on(this,'click',e=>{if(e.target.closest('[data-open-guide]'))window.dispatchEvent(new CustomEvent('vogalab:open-guide',{detail:{channel:this.dataset.channel,key:'help'}}));});

  }
  on(target,event,handler){target.addEventListener(event,handler,{signal:this.abort.signal});}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observers?.forEach(o=>o.disconnect());}
  
 });
})();

  } catch(e) { console.error(e); }
})();
})();
